import { Controller } from "@hotwired/stimulus"

// Handles mobile dropdown tab navigation for tax organizer
// Syncs the dropdown button label with the currently active tab
export default class extends Controller {
  static targets = ["dropdownButton", "currentTabLabel", "tabButton"]

  connect() {
    // Listen for Bootstrap tab shown events to update dropdown label
    // This catches both direct clicks and programmatic tab changes (e.g., from tab-persistence)
    document.addEventListener('shown.bs.tab', this.handleTabChange.bind(this))

    // Sync dropdown label with the currently active desktop tab on initial load
    this.syncWithActiveTab()
  }

  syncWithActiveTab() {
    // Find the currently active desktop tab
    const activeDesktopTab = document.querySelector('[data-bs-toggle="tab"].active')
    if (!activeDesktopTab) return

    const targetId = activeDesktopTab.dataset.bsTarget
    if (!targetId) return

    // Find the corresponding mobile tab button
    const mobileTabButton = this.tabButtonTargets.find(btn =>
      btn.dataset.bsTarget === targetId
    )

    if (mobileTabButton) {
      this.updateDropdownLabel(mobileTabButton)
    }
  }

  disconnect() {
    document.removeEventListener('shown.bs.tab', this.handleTabChange.bind(this))
  }

  // Called when user clicks a dropdown item
  selectTab(event) {
    const button = event.currentTarget
    const tabTarget = button.dataset.bsTarget

    // Find the corresponding desktop tab button and programmatically trigger it
    const desktopTabButton = document.querySelector(`[data-bs-toggle="tab"][data-bs-target="${tabTarget}"]`)
    if (desktopTabButton) {
      // Use Bootstrap's Tab API to show the tab
      const tab = new window.bootstrap.Tab(desktopTabButton)
      tab.show()
    }

    // Update dropdown button label
    this.updateDropdownLabel(button)

    // Close dropdown after selection
    const dropdown = window.bootstrap.Dropdown.getInstance(this.dropdownButtonTarget)
    if (dropdown) {
      dropdown.hide()
    }
  }

  // Handle tab changes from any source (including desktop tabs, persistence, etc.)
  handleTabChange(event) {
    // Find the corresponding mobile tab button for this tab target
    const targetId = event.target.dataset.bsTarget
    if (!targetId) return

    const mobileTabButton = this.tabButtonTargets.find(btn =>
      btn.dataset.bsTarget === targetId
    )

    if (mobileTabButton) {
      this.updateDropdownLabel(mobileTabButton)
    }
  }

  updateDropdownLabel(button) {
    // Extract just the label content (icon + text, without badges)
    const labelContent = button.querySelector('.d-flex > span')
    if (labelContent) {
      this.currentTabLabelTarget.innerHTML = labelContent.innerHTML
    }
  }
}
